module.exports = __webpack_public_path__ + "static/media/29BDOS14.d7cc8b3e.jpg";